import { storage } from "@/lib/appwrite"
import { ID } from "appwrite"
import QRCode from "qrcode"

export const generateAndUploadQR = async (instrumentId: string): Promise<string> => {
    const url = `https://wistrace.wist-ec.com/equipo/${instrumentId}`
    const dataUrl = await QRCode.toDataURL(url, {
        width: 512,
        margin: 2,
        color: { dark: "#000000", light: "#ffffff" }
    })

    // Convierte dataUrl a File
    const res = await fetch(dataUrl)
    const blob = await res.blob()
    const file = new File([blob], `QR-${instrumentId}.png`, { type: "image/png" })

    // Sube a Appwrite
    const uploaded = await storage.createFile(
        import.meta.env.VITE_BLOCKCHAIN_QRINSTRUMENTS_BUCKET_ID,
        ID.unique(),
        file
    )

    return uploaded.$id
}